import Http from 'axios';
import { EventTracking, EventType } from '@app/tracking';
export default class WebVitalsStatistics {
    constructor() {
        EventTracking.listen(EventType.WebVitalsMetric, metric => {
            if (metric.isFinal || metric.name === 'CLS') {
                const isMobile = /Mobi/.test(window.navigator.userAgent);
                Http.post('/api/web-vitals-metric', {
                    type: metric.name,
                    visitor_id: metric.id,
                    value: metric.delta,
                    device: isMobile ? 'mobile' : 'desktop',
                    route: window.location.pathname,
                });
            }
        });
        if (window.laravelDebug) {
            console.log(`✅ Web Vitals Tracking initialized`);
        }
    }
}
